import React, { useEffect, useState } from 'react';
import $ from 'jquery';
import Toastr from 'toastr';
import SessionManager from '../../routes/SessionManager';
import { Button, Input, Radio, Select, Table } from 'antd';
import Modal from 'antd/lib/modal/Modal';


const API_ENDPOINT = {
    FETCH_ROLE_PERMISSIONS: 'https://gygnti76i5.execute-api.us-east-1.amazonaws.com/api-env-prod/common-table-operations/role/fetch',
    FETCH_PERMISSIONS: `https://gygnti76i5.execute-api.us-east-1.amazonaws.com/api-env-prod/common-table-operations/dom/fetch`,
    ADD_PERMISSION: `https://gygnti76i5.execute-api.us-east-1.amazonaws.com/api-env-prod/common-table-operations/dom/create`,
    MODIFY_PERMISSION: `https://gygnti76i5.execute-api.us-east-1.amazonaws.com/api-env-prod/common-table-operations/dom/modify`,
    DELETE_PERMISSION: `https://gygnti76i5.execute-api.us-east-1.amazonaws.com/api-env-prod/common-table-operations/dom/delete`,

    FETCH_GROUP_PERMISSIONS: 'https://gygnti76i5.execute-api.us-east-1.amazonaws.com/api-env-prod/common-table-operations/dom_group/fetch',
    ADD_GROUP_RECORD: `https://gygnti76i5.execute-api.us-east-1.amazonaws.com/api-env-prod/common-table-operations/dom_group/create`,
    DELETE_GROUP_RECORD: `https://gygnti76i5.execute-api.us-east-1.amazonaws.com/api-env-prod/common-table-operations/dom_group/delete`,

    ADD_ROLE_PERMISSION: `https://gygnti76i5.execute-api.us-east-1.amazonaws.com/api-env-prod/common-table-operations/role/create`,
    DELETE_ROLE_PERMISSION: `https://gygnti76i5.execute-api.us-east-1.amazonaws.com/api-env-prod/common-table-operations/role/delete`,
}

function PermissionModal(props) {

    let sessionMgr = new SessionManager();
    let user = sessionMgr.readCookie('user');

    let app_name = 'SITESUPT-UI';
    // let customer_name = user.customer_id;
    let customer_id = user.customer_id;
    let site_id = user.site_selected.site_id;

    let access_type = 'ROLE';
    //console.log('this.customer_name ' + this.customer_name + ', this.customer_id ' + this.customer_id);

    let dom_ids = [
        { value: app_name + '-ACCESS-GROUP-' + access_type, label: 'Access Group' },
    ];

    const dropdownFormatter = (obj) => {
        return <div key={obj.field} className="col-md-6" id="abc">
            <label className="form-group has-float-label">
                <Select labelInValue name="dom_id" onChange={onAccessGroupChange} options={dom_ids} optionLabelProp={"label"} style={{ width: '100%' }} placeholder="Choose Type" />
                {obj.required && <div className="invalid-feedback required">{obj.label} is required</div>}
            </label>
        </div>
    }

    const textFormatter = (obj) => {
        let dom_id = permission.dom_id;
        let el = <></>;

        if (dom_id === app_name + '-' + accessType && obj.field === 'dom_key') {
            // el = <div className="col-md-6" key={obj.field}>
            //     <label className="form-group has-float-label">
            //         <input readOnly className={"form-control not-allowed"} type={obj.type} value={this.customer_name} name={'customer_name'} />
            //         <span>Customer Name</span>
            //     </label>
            // </div>;
        } else {
            el = <div className="col-md-6" key={obj.field}>
                <label className="form-group has-float-label">
                    <input autoComplete="off" className={obj.required ? "form-control required" : "form-control"} type={obj.type} value={permission[obj.field]} name={obj.field} id={obj.field} onChange={handleInputChange} placeholder={obj.label} />
                    {obj.required && <div className="invalid-feedback required">{obj.label} is required</div>}
                </label>
            </div>;
        }
        return el;
    }

    let form_template = [
        { field: 'dom_id', label: 'Type', type: 'text', formatAs: dropdownFormatter, regex: '', required: true },
        { field: 'dom_key', label: 'Key', type: 'text', formatAs: textFormatter, regex: '', required: true },
        { field: 'dom_val', label: 'Value', type: 'text', formatAs: textFormatter, regex: '', required: true }
    ];

    let default_permission = {
        dom_id: 'SITESUPT-UI-' + access_type,
        dom_key: '',
        dom_val: ''
    };

    const [accessType, setAccessType] = useState(access_type);
    const [visible, setVisible] = useState(false);
    const [permission_original, setPermission_original] = useState(props.permission || default_permission);
    const [permission, setPermission] = useState(props.permission || default_permission);
    const [access_permissions, setAccess_permissions] = useState([]);
    const [access_groups, setAccess_groups] = useState(null);
    const [add_or_modify, setAdd_or_modify] = useState('ADD');
    const [trigger, setTrigger] = useState(false);
    const [access_group_permissions, setAccess_group_permissions] = useState(null);
    const [access_group, setAccess_group] = useState(null);

    useEffect(() => {
        fetchAccessPermissionOptions();
        fetchAccessGroups();
        savePermissions();
    }, []);

    const fetchAccessPermissionOptions = () => {
        switch (accessType) {
            case 'ROLE':
                getSiteSuptUIUserPermissions((recs) => {
                    let recsFinal = [];
                    for (let r of recs)
                        if (r.role_permission.indexOf('SITESUPT-UI') === 0)
                            recsFinal.push({
                                group_permission: r.role_permission,
                                group_description: { type: 'permission', name: r.role_permission, description: r.role_description }
                            });
                    setAccess_permissions(recsFinal);
                });
                break;
            default:
                let permissions1 = user.zones.map((a) => {
                    return {
                        group_description: { type: 'location', name: a.location_name, site_id: site_id },
                        group_permission: a.location_id
                    };
                });
                setAccess_permissions(permissions1);
                break;
        }
    }

    const validateForm = () => {
        return new Promise((resolve, reject) => {
            $(".form-control.required:visible").each(function (ele) {
                if ($(this).hasClass('react-dropdown-select')) {
                    if ($(this)[0].outerText === '') {
                        $(this).addClass("is-invalid");
                        $(this).closest("div.required").addClass("show");
                        reject(true);
                    }
                } else if (!$(this).val() || $(this).val().trim().length === 0) {
                    $(this).addClass("is-invalid");
                    $(this).closest("div.required").addClass("show");
                    reject(true);
                    return;
                }
            }).promise().done(() => {
                // Even if not a mandatory, still invalid data needs correction.
                // if ($("input.is-invalid").not('.required').length > 0) {
                //   reject(true);
                // } else {
                //   resolve(true);
                // }
                resolve(true);
            });
        });
    }

    const handleInputChange = ({ target }) => {
        let permissionCopy = { ...permission }
        permissionCopy[target.name] = target.value;

        setPermission(permissionCopy);

        if ($(target).hasClass("required"))
            target.value === "" ? $(target).addClass("is-invalid") : $(target).removeClass("is-invalid");
    }

    const onAccessGroupChange = (obj) => {
        setAccess_group_permissions([]);
        setAccess_group(obj);

        fetchGroupPermissions(obj);
    }

    const saveAccessGroup = () => {
        getMaxAccessGroupId(app_name + '-ACCESS-GROUP', (rec) => {
            let permission1 = {
                dom_id: app_name + '-ACCESS-GROUP-' + accessType + '-' + customer_id,
                dom_key: (parseInt(rec.dom_key) + 1) + '',
                dom_val: permission.dom_val
            };
            validateBeforeSave(permission1);
        });
    }

    const fetchGroupPermissions = (group_id) => {
        let data = {
            "source": "D",
            "criteria": { "from": 0, "size": 1000, "group_id": group_id },
            "user_login": user.user_login,
            "user_token": user.user_token,
            "user_type": "user"
        };

        $.ajax({
            url: API_ENDPOINT.FETCH_GROUP_PERMISSIONS,
            type: 'POST',
            contentType: 'application/json; charset=utf-8',
            dataType: 'json',
            data: JSON.stringify(data)
        }).then(
            res => {
                if (res.status && res.status.code === 200) {
                    if (res.data && res.data.records.length > 0) {
                        let access_group_permissions = [];
                        for (let g of res.data.records) {
                            access_group_permissions.push(g.group_permission);
                        }
                        setAccess_group_permissions(access_group_permissions);
                    } else {
                        return null;
                    }
                } else {
                    setAccess_group_permissions([]);
                }
            },
            res => {
            }
        );
    }

    const fetchAccessGroups = () => {
        let data = {
            "source": "D",
            "criteria": { "from": 0, "size": 1000, "dom_id": "SITESUPT-UI-ACCESS-GROUP-" + accessType + "-" + customer_id },
            "user_login": user.user_login,
            "user_token": user.user_token,
            "user_type": "user"
        };

        $.ajax({
            url: API_ENDPOINT.FETCH_PERMISSIONS,
            type: 'POST',
            contentType: 'application/json; charset=utf-8',
            dataType: 'json',
            data: JSON.stringify(data)
        }).then(
            res => {
                if (res.status && res.status.code === 200) {
                    if (res.data && res.data.records.length > 0) {
                        setAccess_groups(res.data.records);
                    } else {
                        setAccess_groups([]);
                        return null;
                    }
                } else {
                    setAccess_groups([]);
                }
            },
            res => {
                setAccess_groups([]);
            }
        );
    }

    const getSiteSuptUIUserPermissions = (handler) => {
        let data = {
            "source": "D",
            "criteria": { "from": 0, "size": 1000, "role_id": "1" },
            "user_login": user.user_login,
            "user_token": user.user_token,
            "user_type": "user"
        };

        $.ajax({
            url: API_ENDPOINT.FETCH_ROLE_PERMISSIONS,
            type: 'POST',
            contentType: 'application/json; charset=utf-8',
            dataType: 'json',
            data: JSON.stringify(data)
        }).then(
            res => {
                if (res.status && res.status.code === 200) {
                    if (res.data && res.data.records.length > 0) {
                        handler(res.data.records);
                    } else {
                        return null;
                    }
                }
            },
            res => {
            }
        );
    }

    const getMaxAccessGroupId = (dom_id, handler) => {
        let criteria = {
            from: 0,
            size: 1,
            advanced_filter: JSON.stringify([
                { attribute: 'dom_id', value: dom_id, operator: 'like', join_by: 'or' }
            ]),
            sortBy: 'dom_key',
            sortOrder: 'desc',
            sortDataType: 'INTEGER'
        };

        let data = {
            source: 'M',
            criteria: criteria,
            "user_login": user.user_login,
            "user_token": user.user_token,
            "user_type": "user"
        };

        $.ajax({
            url: API_ENDPOINT.FETCH_PERMISSIONS,
            type: 'POST',
            contentType: 'application/json; charset=utf-8',
            dataType: 'json',
            data: JSON.stringify(data)
        }).then(
            res => {
                if (res.status && res.status.code === 200) {
                    if (res.data && res.data.records.length > 0) {
                        handler(res.data.records[0]);
                    } else {
                        return null;
                    }
                }
            },
            res => {
            }
        );
    }

    const validateBeforeSave = (p = permission) => {
        validateForm().then(resolved => {
            let permission = getModifiedAttributes(p);
            //console.log(permission);

            let is_New = !props.permission;
            let url = is_New ? API_ENDPOINT.ADD_PERMISSION : API_ENDPOINT.MODIFY_PERMISSION;
            $.ajax({
                url: url,
                type: 'POST',
                contentType: 'application/json; charset=utf-8',
                dataType: 'json',
                data: JSON.stringify({
                    form_input: permission,
                    "user_login": user.user_login,
                    "user_token": user.user_token,
                    "user_type": "user"
                })
            }).then((res) => {
                if (res.status && res.status.code === 200) {
                    $("#save_permission").toggleClass("disabled ");
                    $("#save_permission").removeAttr("disabled");
                    Toastr.success("Permission " + (is_New ? "created" : "modified") + " successfully !");
                    setAccess_groups([]);
                } else {
                    Toastr.error("Unable to " + (is_New ? "create" : "modify") + " permission !");
                    $("#save_permission").toggleClass("disabled ");
                    $("#save_permission").removeAttr("disabled");
                }
            });

        }, () => {
            Toastr.error('Please correct validation errors to continue ...', 'Error');
            $("#save_permission").removeClass("disabled ");
            $("#save_permission").removeAttr("disabled");
        }).catch(() => {
            $("#save_permission").removeClass("disabled ");
            $("#save_permission").removeAttr("disabled");
        });
    }

    const savePermissions = () => {
        let permissions = [];// ["SITESUPT-ADMIN-PERMISSION-EDIT"];
        for (let p of permissions) {
            let url = API_ENDPOINT.ADD_PERMISSION;
            $.ajax({
                url: url,
                type: 'POST',
                contentType: 'application/json; charset=utf-8',
                dataType: 'json',
                data: JSON.stringify({
                    form_input: { dom_id: "SITESUPT-ADMIN-PERMISSION", dom_key: p, dom_val: p },
                    "user_login": user.user_login,
                    "user_token": user.user_token,
                    "user_type": "user"
                })
            }).then((res) => {
                //console.log(res);
            });
        }
    }

    const getModifiedAttributes = (c1 = permission) => {
        let c0 = permission_original;
        let modifiedAtts = {};
        for (let k in c1) {
            if (c0[k] === undefined || c1[k] + '' !== c0[k] + '') {
                if (typeof c1[k] === 'string')
                    c1[k] = (c1[k] + '');
                modifiedAtts[k] = c1[k];
            }
        }

        return modifiedAtts;
    }

    const showModal = () => {
        setVisible(true);
    }

    const closeModal = () => {
        setVisible(false);
    }

    const isSaveDisabled = () => {
        if (add_or_modify === 'ADD') {
            return !access_group || access_group.trim().length === 0;
        } else {
            return false;
        }
    }

    const saveAccessGroupModal = () => {
        if (add_or_modify === 'ADD') {
            setPermission({ dom_id: app_name + '-' + accessType, dom_val: access_group });
            setTrigger(true);
        } else {

        }
    }

    useEffect(() => {
        if (trigger && add_or_modify === 'ADD') {
            saveAccessGroup();
        } else {

        }
    }, [permission]);

    const handleAccessTypeChange = (v) => {
        default_permission.dom_id = 'SITESUPT-UI-' + v;

        setAccessType(v);
        setAccess_groups([]);
        setAccess_group_permissions([]);
        setAccess_group(null);
        setAccess_permissions([]);
        setPermission(default_permission);
        setPermission_original(default_permission);

        fetchAccessPermissionOptions();
        fetchAccessGroups();
    }

    const onCheckboxChange = (v) => {
        //console.log('selectedRows', v);
        setAccess_group_permissions(v);
    }

    const onCheckboxClick = (v, selected) => {
        $.ajax({
            url: selected ? API_ENDPOINT.ADD_GROUP_RECORD : API_ENDPOINT.DELETE_GROUP_RECORD,
            type: 'POST',
            contentType: 'application/json; charset=utf-8',
            dataType: 'json',
            data: JSON.stringify({
                form_input: selected ?
                    { group_id: access_group, ...v } :
                    { group_id: access_group, group_permission: v.group_permission },
                "user_login": user.user_login,
                "user_token": user.user_token,
                "user_type": "user"
            })
        }).then((res) => {
            if (res.status && res.status.code === 200) {
                Toastr.success("Saved preference successfully !");
            }
        });

        //if (this.state.access_type === 'ZONE') {
        // } else if (this.state.access_type === 'ROLE') {
        //     $.ajax({
        //         url: selected ? API_ENDPOINT.ADD_ROLE_PERMISSION : API_ENDPOINT.DELETE_ROLE_PERMISSION,
        //         type: 'POST',
        //         contentType: 'application/json; charset=utf-8',
        //         dataType: 'json',
        //         data: JSON.stringify({
        //             form_input: selected ?
        //                 { role_id: this.state.access_group, ...v } :
        //                 { role_id: this.state.access_group, role_permission: v.role_permission },
        //             "user_login": this.user.user_login,
        //             "user_token": this.user.user_token,
        //             "user_type": "user"
        //         })
        //     }).then((res) => {
        //         if (res.status && res.status === 200) {
        //             Toastr.success("Saved preference successfully !");
        //         }
        //     });
        // }
    }

    const onAccessGroupOperationChange = (v) => {
        setAdd_or_modify(v.target.value);
        setAccess_group(null);
    }

    useEffect(() => {
        if (access_groups === null || access_groups.length === 0) {
            fetchAccessGroups();
        }
    }, [add_or_modify]);

    let accessGroupTitle = accessType === "ROLE" ? "Permission" : "Zone Name";
    let access_group_columns = [{
        title: accessGroupTitle,
        dataIndex: 'group_permission',
        key: 'group_permission',
        render: (text, record) => record.group_description.name
    }];

    let dom_id = permission.dom_id;
    if (dom_id === app_name + '-' + accessType) {
        form_template[2].label = 'Access Group Name';
    } else if (dom_id === 'SITESUPT-APPLICATION') {
        form_template[1].label = 'Application Key';
        form_template[2].label = 'Application Name';
    } else if (dom_id === app_name + '-PERMISSION') {
        form_template[1].label = 'Permission Key';
        form_template[2].label = 'Permission Description';
    }

    if (add_or_modify === 'EDIT')
        $('.ant-modal-footer').hide();
    else
        $('.ant-modal-footer').show();

    return (
        <React.Fragment>
            <Button type="primary" onClick={showModal}>
                Add or Edit Access Group
            </Button>

            <Modal
                okText="Save"
                onOk={saveAccessGroupModal}
                okButtonProps={{ id: 'save_permission', disabled: isSaveDisabled() }}
                onCancel={closeModal}
                visible={visible}
                size="modal-md">
                <div className="modal-body">
                    <div className="row pb-2">
                        <div className="col-md-12">
                            Access Type : &nbsp;
                        </div>
                    </div>
                    <div className="row pb-2">
                        <div className="col-md-12">
                            <Select
                                value={accessType || ''}
                                onChange={handleAccessTypeChange}
                                options={[{ dom_key: 'ROLE', dom_val: 'User Access' }, { dom_key: 'ZONE', dom_val: 'Zone Access' }].map((a) => { return { value: a.dom_key, label: a.dom_val }; })}
                                style={{ width: '100%' }}
                                placeholder="Choose Access Type" />
                        </div>
                    </div>
                    <div className="row pb-2">
                        <div className="col-md-12">
                            Access Group : &nbsp;
                            <Radio.Group onChange={(v) => onAccessGroupOperationChange(v)} value={add_or_modify}>
                                <Radio value={'ADD'}>Add</Radio>
                                <Radio value={'EDIT'}>Edit</Radio>
                            </Radio.Group>
                        </div>
                    </div>
                    <div className="row">
                        {add_or_modify === 'EDIT' ?
                            <div className="col-md-12">
                                <Select
                                    value={access_group || ''}
                                    loading={access_groups === null}
                                    onChange={onAccessGroupChange}
                                    options={access_groups ? access_groups.map((a) => { return { value: a.dom_key, label: a.dom_val }; }) : []}
                                    style={{ width: '100%' }}
                                    placeholder={!access_groups ? "Fetching access groups" : access_groups.length > 0 ? "Choose Access Group" : "No Access Groups found ..."} />
                            </div>
                            :
                            <div className="col-md-12">
                                <Input onChange={(v) => setAccess_group(v.target.value)} value={access_group} />
                            </div>
                        }
                    </div>

                    <div className="row py-2">
                        <div className="col-md-12">
                            {add_or_modify === 'EDIT' && access_group && <Table pagination={false} style={{ width: '100%' }} rowSelection={{ hideSelectAll: true, selectionType: 'checkbox', selectedRowKeys: access_group_permissions, onChange: (v) => onCheckboxChange(v), onSelect: (a, b, c) => onCheckboxClick(a, b, c) }} rowKey={'group_permission'} columns={access_group_columns} dataSource={access_permissions}></Table>}
                        </div>
                    </div>

                </div>
            </Modal>

        </React.Fragment >
    );
}

export default PermissionModal;